<template>
  <router-view />
  <v-container fluid class="fill-height">
    <v-row>
      <v-col class="d-flex justify-center">
        <v-img
            :src="require('../assets/LogoAppBorder.png')"

            contain
            height="200"
        />

      </v-col>
      <v-progress-circular
          color="green"
          class="loading"
          indeterminate
      ></v-progress-circular>
    </v-row>

  </v-container>


</template>

<script>


import router from "@/router";

export default {
  name: 'Splesh',
  data: () =>({
    auth : {
      token: "",
      user :{
        name : "",
        phone : "",
        profile : "",
      }
    }
  }),
  mounted () {
    this.intervalid1 = setInterval(() => {
      // localStorage.setItem("token","T3RURm5MU2g2MjJOUWk2bXpvQ0YzRUNyeEtOR2VwcGhMcEp3NVNWQlNkamNSbmN5L1RKQXEwdTBDZGJWWXVFMTlSbUw5MkdZWnB2YUdzbWphVjE5dG9uOVljY1YwRllpNXlGd0txRjV1Z3JTYUtjWUgxMm00Nkdtajl1OW1wZCtRWFBsT2JUU2pqVnpQd3F0d00wK2w4SGdZTkxYakpKVXVtZFd5Uk4vSVpNVlNTbkc0Z0I5OGtha1RETGhWT3NDa0tGZEp2YldsS3ZFdlkreFZTN2xhdmpsMkJhUllNcHJzMHBiMis5M0ptNk43RTgxUzJ6VE1XdnNCc0NXODNydFEwUTJyRzFWQytpV1ArSk1hUW1oY2c9PTo6NCfWjpjaAd27DNNz7ZXDHg==");
      this.auth.token = localStorage.getItem("token");
      this.auth.user.name = localStorage.getItem("user_name");
      this.auth.user.phone = localStorage.getItem("user_phone");
      this.auth.user.profile = localStorage.getItem("user_profile");
      if(this.auth.token !=null){
        window.location.href = '/home'
      }else{
        window.location.href = '/login'
      }

    }, 3000);
  }
}
</script>
<style>
  .loading{
    position: absolute;
    top: 65%;
    left: 49%;
  }

</style>
